export default {
  'alert-template-page_new_email': 'Email addresses do not match',
  'alert-template-page_new_sms_number': 'The phone numbers you have entered do not match'
};

